import ReactPlayer from "react-player";
import { getText } from "../../utils/languageUtils";

const VideoSection = ({
    videoData,
    language,
    setQuizStage,
    setStartQuiz,
    translationData
}) => {
const translations = translationData?.baseline || {};
    return (
        <div className="container-fluid px-0">
            <div className="row justify-content-center">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-md-12">
                    <section className="my-3">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="sectionsBox">
                                        <p className="mb-0 text-center">{getText(videoData?.baseline_video_summary?.title, language)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {/* <p>{`${getText(videoData?.baseline_video_summary?.video_link, language)}-U`}</p> */}
                                    <div className="my-3 d-flex justify-content-center">

                                        <ReactPlayer
                                            url={`${getText(videoData?.baseline_video_summary?.video_link, language)}-U`}
                                            playing={true}
                                            width="640px"
                                            height='360px'
                                            controls={true}

                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 ">
                                {/* {getText(videoData?.baseline_video_summary?.description, language).length > 0 && <div className="contentbox mb-4">
                                                        <div className="content_safty ">
                                                            {parse(getText(videoData?.baseline_video_summary?.description, language))}
                                                        </div>
                                                    </div>
                                                    } */}
                            </div>


                            <div className="col-12 d-flex justify-content-center">
                                <button onClick={() => { setQuizStage('intro') }} type="button" className="btn btn-danger  custom-button-next">
                                    {getText(translations.next, language)}
                                </button>
                            </div>


                        </div>
                    </section>
                </div>
            </div>

        </div>
    )
}

export default VideoSection